module.exports = __webpack_public_path__ + "img/曾敏刚.1d827c33.jpg";